import { getAccessToken } from "@newsenec/auth-provider";
import { CockpitNotification } from "./notification";

export type ReadNotification = {
    id: string;
    type: string;
};

const fppNotificationUrl: string = process.env.FPP_BACKEND_NOTIFICATION_URL || location.origin + "/api/fpp/notifications";

export async function fetchMarkedAsRead(): Promise<ReadNotification[]> {
    const token = await getAccessToken();
    const response = await fetch(fppNotificationUrl + "/marked-as-read", {
        method: "GET",
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
        },
    });
    return response.ok ? response.json() : Promise.reject();
}

export async function markAsRead(notifications: CockpitNotification[]): Promise<ReadNotification[]> {
    const token = await getAccessToken();
    const readNotifications: ReadNotification[] = notifications.map((n) => ({
        id: n.id,
        type: n.type,
    }));
    const response = await fetch(fppNotificationUrl, {
        method: "POST",
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(readNotifications),
    });
    return response.ok ? response.json() : Promise.reject();
}
